"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListAuthOrganisationsResponseSchema = exports.ListAuthOrganisationsQuerySchema = exports.UpdateAuthOrganisationResponseSchema = exports.UpdateAuthOrganisationBodySchema = exports.ParentAndChildOrgRefParamsSchema = exports.AuthOrganisationSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_proxy_web_1 = require("../../apple-proxy-web");
const common_1 = require("../common");
exports.AuthOrganisationSchema = (0, core_1.StrictObject)({
    currency: core_1.CurrencySchema,
    orgName: core_1.NameSchema,
    orgRef: ruby_1.AppleProxyOrgRefSchema,
    parentOrgRef: ruby_1.AppleProxyOrgRefSchema,
    applePaymentModel: apple_proxy_web_1.AppleProxyPaymentModelSchema,
    orphaned: typebox_1.Type.Boolean({
        title: "Orphaned",
        description: "Do we have access to this organisation at present?",
    }),
    status: common_1.AppleOrganisationInfoStatusSchema,
    teamIds: typebox_1.Type.Array(core_1.IdSchema),
});
exports.ParentAndChildOrgRefParamsSchema = (0, core_1.StrictObject)({
    parentOrgRef: ruby_1.AppleProxyRefSchema,
    orgRef: ruby_1.AppleProxyRefSchema,
});
exports.UpdateAuthOrganisationBodySchema = (0, core_1.StrictObject)({
    status: typebox_1.Type.Optional(common_1.AppleOrganisationInfoStatusSchema),
    teamIds: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.IdSchema)),
});
exports.UpdateAuthOrganisationResponseSchema = exports.AuthOrganisationSchema;
exports.ListAuthOrganisationsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    status: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.AppleOrganisationInfoStatusSchema)),
    currency: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.CurrencySchema)),
    teamId: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.IdSchema)),
    parentOrgRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyOrgRefSchema)),
    orgRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyOrgRefSchema)),
});
exports.ListAuthOrganisationsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AuthOrganisationSchema);
